import { resolveUnit } from "@esgt/helpers"
import type { KpiUnit } from "@esgt/types"

/**
 * Format a raw KPI value according to its unit's rules, **without** appending
 * the unit label.
 *
 * Returns e.g. `"1 234"` for numeric units, `"Ja"` for bool units.
 */
export function formatKpiValue(
  rawValue: string,
  unit: KpiUnit,
  answerValues?: Record<string, Record<string, string> | undefined>,
): string {
  return resolveUnit(unit, "nb", answerValues).formatValue(rawValue)
}

/**
 * Resolve the display label for a KPI unit (without formatting a value).
 */
export function getKpiUnitLabel(
  unit: KpiUnit,
  answerValues?: Record<string, Record<string, string> | undefined>,
): string {
  return resolveUnit(unit, "nb", answerValues).label
}
